import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class AppInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            errors: {},
            loading: false,
            userID: props.location.search == ''  ? '' :  props.location.search.split('&')[0].split('=')[1],
            userEmail: props.location.search == '' ? '' : props.location.search.split('&')[1].split('=')[1],
        };

        this.RedirectClientLogin = this.RedirectClientLogin.bind(this);
    }
    componentDidMount() {
        //alert('MSSO:' + this.state.userEmail);
            this.setState({ loading: true });
            const cID = document.cookie
                .split("; ")
                .find((row) => row.startsWith("userID="))
                ?.split("=")[1];
            const cEmail = document.cookie
                .split("; ")
                .find((row) => row.startsWith("userEmail="))
                ?.split("=")[1];
            let activeID = (cID === undefined) ? (this.state.userID == '') ? '' : this.state.userID : cID;
            let activeEmail = (cEmail === undefined) ? (this.state.userEmail == '') ? '' : this.state.userEmail : cEmail;
            //alert(`[cookie] ID=${cID}, Email=${cEmail}\n[MSSO] ID=${activeID},Email=${activeEmail}`);
            //if (activeID != '' && activeEmail != '')
            {
                axios.get(`${Constants.apiURL}/api/Identity/VerifyMSSOLogin`, {
                    params: {
                        userID: activeID,
                        userEmail: activeEmail
                    }
                }).then(response => {
                    if (response.data) {
                        if (response.data.succeeded == true) {
                            if (cID === undefined || cEmail === undefined) {
                                this.setMSSOCookie();
                            }
                            this.props.history.push({
                                pathname: '/boland_landing_page',
                                state: {
                                    user: response.data.user
                                }
                            });
                            ReactGA.set({ userId: response.data.user.username });
                            ReactGA.event({
                                category: 'Login',
                                action: 'Login',
                                label: 'Login'
                            });
                        }
                    }
                    this.setState({ loading: false });
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ loading: false });
                    //alert('Boland SSO login failed')
                });
            }
        }
        setMSSOCookie() {
            var dt = new Date();
            dt.setMonth(dt.getMonth() + 1);
            var strID = "userID=" + this.state.userID + ";expires=" + dt.toUTCString() + ";path=/;";
            document.cookie = strID;
            var strEmail = "userEmail=" + this.state.userEmail + ";expires=" + dt.toUTCString() + ";path=/;";
            document.cookie = strEmail;
            // read cookie back for testing
        //    const cID = document.cookie
        //        .split("; ")
        //        .find((row) => row.startsWith("userID="))
        //        ?.split("=")[1];
        //    const cEmail = document.cookie
        //        .split("; ")
        //        .find((row) => row.startsWith("userEmail="))
        //        ?.split("=")[1];
        //alert(`Email: ${cEmail}, ID=${cID}`);

    }

    RedirectClientLogin() {
        window.location = `${Constants.apiURL}`;// 'https://clientportalstaging.boland.com';
        //this.props.history.push({
        //    pathname: '/login'
        //});
    }

    render() {
        return (

            <div>
                <GuestSiteMenu currentPage='login_option' />
                <div style={{ padding: '20px' }}>
                    <Form  noValidate >
                        <Form.Label className="form-header">Login Options</Form.Label>
                        <Row>
                            <Col md={2}>
                                <Button style={{ fontSize: '22px', alignContent: 'center', marginTop: '5px', backgroundColor: '#1F419B', width: '240px', height: '40px' }}
                                    variant="primary" onClick={this.RedirectClientLogin}>Client Login</Button>
                                <div style={{height:'8px'}} />
                            {/*</Col>*/}
                            {/*<Col>*/}
                                {/*<a href="https://login.microsoftonline.com/f9b9ae6d-340b-4675-891a-d6d094f4eb4e/oauth2/v2.0/authorize?client_id=1b6406e6-2275-49cb-8910-f17d4664037b&redirect_uri=https%3A%2F%2Fclientportaldev.boland.com/home/index%2F&response_type=code%20id_token&scope=openid%20profile&state=OpenIdConnect.AuthenticationProperties%3DpWIP-pWuvztvXrHQ9YLvq5mzoaVR_zmwd5tCGDPOcwysEjBPbSAJRjDrjX6v6Sm5y5CXXugQJkBCDff50pTjTPbImwtEVlpM4LeLBSH3OLoep4s9AJ6pCGx5_SQdi6y8omC3oHJefHcg-ogXwTO_4zXQCj58S9Ps_3wrbpM_8t__kNlx-Dmu70_PB4qFnqBQMlyD3BVyN5ab8kSWztXvlw&response_mode=form_post&nonce=638520090035743553.NWZiZGQxMWQtMDZkYy00ZWZkLThlYjUtMjM3NTRhN2YxNjY2MDc3MmFlZmYtN2QyNy00YzJjLTg1MzItOWJiNDdjNjc2OWVi&x-client-SKU=ID_NET461&x-client-ver=6.8.0.0&sso_reload=true">*/}
                                <a href="https://clientportaldev.boland.com/home/signin">
                                    <Image src="./SignInWithMicrosoft.jpg" width="240" height="40" />
                                </a>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        );
    }
}

export default AppInfo;